import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import apiClient from 'src/helpers/apiClient';
import { getFormattedErr } from 'src/helpers';

export const fetchEmployerFeedbackStatus = createAsyncThunk(
  'employerFeedback/fetchStatus',
  async ({ orgId }: { orgId: string }, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getGeneralApi()
      ).generalApiGetEmployerFeedbackStatus({ orgId });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const submitEmployerFeedback = createAsyncThunk(
  'employerFeedback/submit',
  async (
    {
      orgId,
      selectedOptions,
      customFeedback,
    }: { orgId: string; selectedOptions: string[]; customFeedback?: string },
    { rejectWithValue },
  ) => {
    try {
      const response = await (
        await apiClient.getGeneralApi()
      ).generalApiCreateEmployerFeedback({
        orgId,
        employerFeedbackBody: {
          selected_options: selectedOptions,
          custom_feedback: customFeedback,
        },
      });
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error), {
        variant: 'error',
      });
      return rejectWithValue(err?.response?.data);
    }
  },
);
